import React from 'react';
import { CacheProvider } from '@emotion/core';
import { ThemeProvider as ChakraThemeProvider } from '@chakra-ui/core';
import { getMergedTheme } from '../styles/theme';
import { cache } from '../styles/emotion';
export default function ThemeProvider(_ref) {
  var _window$d, _window$d$store;

  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      children = _ref.children;
  // If a theme exists, grab it and add it to the theme provider
  var storedTheme = ((_window$d = window.d3) === null || _window$d === void 0 ? void 0 : (_window$d$store = _window$d.store) === null || _window$d$store === void 0 ? void 0 : _window$d$store.getState().theme) || {};
  var mergedTheme = getMergedTheme(theme, storedTheme);
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: cache
  }, /*#__PURE__*/React.createElement(ChakraThemeProvider, {
    theme: mergedTheme
  }, children));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/components/ThemeProvider.js
// module id = 316
// module chunks = 0